/**
 * @generated SignedSource<<7741c6b2bc6bf3f1e2e60bef0caa1364>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContemporaryLandingMakersModule_contemporaryLandingRow$data = {
  readonly items: ReadonlyArray<{
    readonly items?: ReadonlyArray<{
      readonly bgImagePath?: string | null;
      readonly imagePath?: string | null;
      readonly location?: string | null;
      readonly name?: string | null;
      readonly text?: string | null;
      readonly type?: string | null;
      readonly url?: string | null;
      readonly userImagePath?: string | null;
    } | null> | null;
    readonly text?: string | null;
    readonly type?: string | null;
  } | null> | null;
  readonly " $fragmentType": "ContemporaryLandingMakersModule_contemporaryLandingRow";
};
export type ContemporaryLandingMakersModule_contemporaryLandingRow$key = {
  readonly " $data"?: ContemporaryLandingMakersModule_contemporaryLandingRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContemporaryLandingMakersModule_contemporaryLandingRow">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContemporaryLandingMakersModule_contemporaryLandingRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/)
          ],
          "type": "ContemporaryLandingHeader",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bgImagePath",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "location",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    (v1/*:: as any*/),
                    (v2/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "userImagePath",
                      "storageKey": null
                    }
                  ],
                  "type": "ContemporaryLandingHeroMakerRowItem",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "imagePath",
                      "storageKey": null
                    },
                    (v0/*:: as any*/),
                    (v1/*:: as any*/),
                    (v2/*:: as any*/)
                  ],
                  "type": "ContemporaryLandingMakerRowItem",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v1/*:: as any*/)
          ],
          "type": "ContemporaryLandingRow",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContemporaryLandingRow",
  "abstractKey": null
};
})();

(node as any).hash = "9dce0cc3a3156555111dc290a0b4bbb3";

export default node;
